import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default function(WrappedComponent) {
  class Container extends Component {
    static displayName = 'CreateUserModalContainer'

    static propTypes = {
      close: PropTypes.func.isRequired,
      create: PropTypes.func.isRequired,
      hasError: PropTypes.bool.isRequired,
      isPending: PropTypes.bool.isRequired,
    }

    state = {
      email: '',
      firstName: '',
      lastName: '',
    }

    handleCreate = e => {
      const { create } = this.props
      const { email, firstName, lastName } = this.state

      e.preventDefault()

      create(email, firstName, lastName)
    }

    handleEmailChanged = (e, { value: email }) => {
      this.setState({ email })
    }

    handleFirstNameChanged = (e, { value: firstName }) => {
      this.setState({ firstName })
    }

    handleLastNameChanged = (e, { value: lastName }) => {
      this.setState({ lastName })
    }

    render() {
      return (
        <WrappedComponent
          close={this.props.close}
          email={this.state.email}
          firstName={this.state.firstName}
          handleCreate={this.handleCreate}
          handleEmailChanged={this.handleEmailChanged}
          handleFirstNameChanged={this.handleFirstNameChanged}
          handleLastNameChanged={this.handleLastNameChanged}
          hasError={this.props.hasError}
          isPending={this.props.isPending}
          lastName={this.state.lastName}
        />
      )
    }
  }

  return Container
}
